import type { FavoriteCompanyDto } from '@/types/dto/company-favorite.dto';
import type { FavoriteShopSnapshot } from '@/types/profile';

function normalizeText(value?: string | null) {
  const normalizedValue = value?.trim();

  return normalizedValue ? normalizedValue : null;
}

export function sanitizeFavoriteShop(item: FavoriteShopSnapshot): FavoriteShopSnapshot {
  return {
    id: item.id,
    locationLabel: normalizeText(item.locationLabel),
    name: normalizeText(item.name),
    profilePhoto: normalizeText(item.profilePhoto),
    slug: normalizeText(item.slug),
  };
}

export function mergeFavoriteShop(current: FavoriteShopSnapshot, nextItem: FavoriteShopSnapshot): FavoriteShopSnapshot {
  const sanitizedNextItem = sanitizeFavoriteShop(nextItem);

  return {
    id: current.id,
    locationLabel: sanitizedNextItem.locationLabel ?? current.locationLabel ?? null,
    name: sanitizedNextItem.name ?? current.name ?? null,
    profilePhoto: sanitizedNextItem.profilePhoto ?? current.profilePhoto ?? null,
    slug: sanitizedNextItem.slug ?? current.slug ?? null,
  };
}

export function buildFavoriteShopSnapshot(company: FavoriteCompanyDto): FavoriteShopSnapshot {
  const cityName = normalizeText(company.city?.name);
  const stateCode = normalizeText(company.city?.state?.stateCode);
  const neighborhoodLabel = normalizeText(company.neighborhood);
  const cityLabel =
    cityName && stateCode
      ? neighborhoodLabel
        ? `${neighborhoodLabel}, ${cityName} - ${stateCode}`
        : `${cityName} - ${stateCode}`
      : (neighborhoodLabel ?? cityName);

  return sanitizeFavoriteShop({
    id: company.id,
    locationLabel: cityLabel,
    name: normalizeText(company.name),
    profilePhoto: normalizeText(company.profilePhoto),
    slug: normalizeText(company.slug),
  });
}
